import React, { ReactNode, useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { headingFont } from 'src/ui/theme/tokens'

export default function DiscoverabilityAccordion({
  children,
  autoExpandKey,
  poll = false,
  onToggle,
}: {
  children: ReactNode
  autoExpandKey: string
  poll?: boolean
  onToggle?: () => void
}) {
  const [preference, setPreference] = useState({
    key: autoExpandKey,
    expanded: !!autoExpandKey,
  })
  const expanded =
    preference.key === autoExpandKey ? preference.expanded : !!autoExpandKey

  return (
    <Accordion
      expanded={expanded}
      onChange={(_event, next) => {
        onToggle?.()
        setPreference({ key: autoExpandKey, expanded: next })
      }}
      disableGutters
      TransitionProps={{ timeout: { enter: 280, exit: 220 } }}
      sx={{ overflow: 'hidden', '&::before': { display: 'none' } }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreRoundedIcon sx={poll ? { color: '#944217' } : undefined} />
        }
        sx={{
          background: '#ffffff',
          minHeight: 64,
          px: { xs: 2, sm: 3 },
          '& .MuiAccordionSummary-content': { my: 1.5 },
        }}
      >
        <Box textAlign="left">
          <Typography
            variant="h6"
            sx={{
              fontFamily: headingFont,
              fontWeight: 800,
              fontSize: 18,
              ...(poll && { color: '#693413' }),
            }}
          >
            Discoverability
          </Typography>
          <Typography
            variant="caption"
            color={poll ? '#855c3d' : 'text.secondary'}
          >
            Categories, tags & visibility
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        sx={{ p: { xs: 2, sm: 3 }, background: '#ffffff' }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}
